import AddressService from '../services/AddressService';
import ServiceMixin from './ServiceMixin';

export default {
  mixins: [ServiceMixin],
  data: () => ({
    addressList: [],
    addressConfig: {
      errorMessage: 'Falha ao buscar endereços!',
      showSuccessSwal: false,
    },
    addressLoading: false,
    saveAddressLoading: false,
  }),
  watch: {
    addressList: {
      deep: true,
      immediate: true,
      handler(arr) {
        if (Array.isArray(arr) && arr.length >= 1) {
          this.handleAddressPayload(arr);
        }
      },
    },
  },
  computed: {
    disabledDatList() {
      return (name) => !(this.getInAddressList(name).length < 2);
    },
    getInAddressList() {
      return (key) => this.addressList.map(
        (item) => item[key],
      );
    },
    getPostalCode() {
      return '';
    },
    getAddressRequest() {
      return (params = {}) => AddressService.list(
        this.makeParams({
          PostalCode: this.getPostalCode,
          ...params,
        }),
      );
    },
  },
  methods: {
    handleAddressPayload(payload) {
      return payload;
    },
    searchAddress() {
      this.handleAddressLoading();
      this.makeAddressRequestList();
    },
    handleAddressLoading() {
      this.addressLoading = !this.addressLoading;
    },
    makeAddressRequestList() {
      this.callService(
        this.getAddressRequest(),
        this.addressConfig,
        this.prepareDataAddress,
      );
    },
    prepareDataAddress(response) {
      if (this.isPaginated(response)) {
        this.getAllAddress(response);
      } else {
        this.setAddressList(response);
      }
    },
    isPaginated(response) {
      return this.hasData(response)
        && response.data.total > 1000;
    },
    getAllAddress(response) {
      this.callService(
        this.makeAddressPromisesRequest(
          response.data.lastPage,
          this.prepareDataAddress(response.data),
        ),
        this.addressConfig,
        this.setAddressList,
      );
    },
    makeAddressPromisesRequest(pages, initialAddress) {
      return Promise.all(
        this.makeAddressPromiseArray(pages),
      )
        .then(
          this.makeOneAddressListResponse(initialAddress),
        );
    },
    makeAddressPromiseArray(pages) {
      const promises = [];

      for (let page = 2; page <= pages; page += 1) {
        promises.push(
          this.getAddressRequest({
            Page: page,
          }),
        );
      }

      return promises;
    },
    makeOneAddressListResponse(initialAddress) {
      return (responses) => ({
        data: {
          data: this.makeOneAddressListObj(responses, initialAddress),
        },
      });
    },
    makeOneAddressListObj(responses, initialAddress) {
      return [
        ...initialAddress,
        ...responses.reduce(
          this.groupAddressInOnlyArr(),
          [],
        ),
      ];
    },
    groupAddressInOnlyArr() {
      return (acc, crr) => {
        if (Array.isArray(acc)) {
          acc.forEach(
            (item) => crr.push(item),
          );
        } else {
          crr.push(acc);
        }

        return crr;
      };
    },
    setAddressList(response) {
      this.handleAddressLoading();
      if (this.hasData(response)) {
        this.addressList = this.prepareData(response.data);
      }
    },
    saveAddress({ config, cb = null, payload } = {}) {
      this.handleAddressLoading();
      this.makeAddAddressRequest({
        config,
        cb,
        payload,
      });
    },
    handleSaveAddressLoading() {
      this.saveAddressLoading = !this.saveAddressLoading;
    },
    makeAddAddressRequest({ payload, cb, config = {} } = {}) {
      const { message, ...restConfig } = config;
      this.callService(
        AddressService.add(
          this.prepareAddressAddPayload(
            payload,
          ),
        ),
        {
          ...this.addressConfig,
          ...restConfig,
          errorMessage: message || 'Falha ao salvar endereço!',
        },
        (response) => {
          this.prepareAddAddressCb(
            response,
            cb,
          );
        },
      );
    },
    prepareAddressAddPayload(payload = {}) {
      const item = this.addressList.find(
        ({ bairro }) => bairro === payload.bairro,
      );
      const bairroId = item ? item.bairroId : '';
      const { bairro, tipoLogradouro, ...rest } = payload;
      return {
        tipo_logradouro: tipoLogradouro,
        ...rest,
        ...(bairroId ? { bairroId } : { bairro })
        ,
      };
    },
    prepareAddAddressCb(response, cb) {
      if (this.hasData(response)) {
        if (cb) {
          const res = cb(
            response.data,
            this.handleSaveAddressLoading,
          );
          if (res instanceof Promise) {
            res.catch(
              (err) => {
                this.showMessageError(err);
              },
            ).finally(
              this.nextHandleAddressLoading,
            );
          }
        } else {
          this.nextHandleAddressLoading();
        }
      } else {
        this.nextHandleAddressLoading();
      }
    },
    nextHandleAddressLoading() {
      this.$nextTick(
        () => {
          if (this.addressLoading) {
            this.addressLoading = false;
          }
        },
      );
    },
  },
};
